// @copyright  2006 - 2024 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'team-member-payment-detail.page.title': 'Payment Details',
    'team-member-payment-detail.page.search_results': 'Search Results',
    'team-member-payment-detail.page.create.title': 'Create New Payment Detail',
    'team-member-payment-detail.page.search.title': 'Find Payment Details',
    'team-member-payment-detail.page.edit.title': 'Edit Payment Detail',
    'team-member-payment-detail.page.view.title': 'View Payment Detail',
    'team-member-payment-detail.page.all': 'All',

    'team-member-payment-detail.button.cancel': 'Cancel',
    'team-member-payment-detail.button.select': 'Select',
    'team-member-payment-detail.button.find': 'Find Payment Details',
    'team-member-payment-detail.button.search': 'Apply',
    'team-member-payment-detail.button.create': 'Create Payment Detail',
    'team-member-payment-detail.button.new': 'New Payment Detail',
    'team-member-payment-detail.button.save': 'Save Changes',
    'team-member-payment-detail.button.delete': 'Permanently Delete',
    'team-member-payment-detail.button.edit': 'Edit',
    'team-member-payment-detail.button.restore': 'Restore',
    'team-member-payment-detail.button.reset': 'Reset',

    'team-member-payment-detail.placeholder.search': 'Search payment details',

    'team-member-payment-detail.link.create_first_team_member_payment_detail': 'Click here to create your first payment detail',
    'team-member-payment-detail.link.team_member_payment_details': ' Return to Payment Details',
    'team-member-payment-detail.link.retry': 'Click here to retry',

    'team-member-payment-detail.checkbox.all': 'Check All',
    'team-member-payment-detail.checkbox.actions_label': 'with selected',

    'team-member-payment-detail.label.payroll_payment_method_name': 'Payroll Payment Method',
    'team-member-payment-detail.label.team_member_name': 'Team Member',
    'team-member-payment-detail.label.currency_name': 'Currency',
    'team-member-payment-detail.label.cheque_payable_to': 'Cheque Payable To',
    'team-member-payment-detail.label.mailing_address': 'Mailing Address',
    'team-member-payment-detail.label.bank_name': 'Bank Name',
    'team-member-payment-detail.label.account_holder_name': 'Account Holder Name',
    'team-member-payment-detail.label.account_number': 'Account Number',
    'team-member-payment-detail.label.routing_number': 'Routing Number',
    'team-member-payment-detail.label.swift_code': 'Swift Code',
    'team-member-payment-detail.label.iban': 'IBAN',
    'team-member-payment-detail.label.correspondent_bank': 'Correspondent Bank',
    'team-member-payment-detail.label.bank_address': 'Bank Address',
    'team-member-payment-detail.label.correspondent_bank_swift': 'Correspondent Bank Swift',
    'team-member-payment-detail.label.additional_details': 'Additional Details',
    'team-member-payment-detail.label.is_verified': 'Is Verified',
    'team-member-payment-detail.label.from__created_at': 'From created at',
    'team-member-payment-detail.label.to__created_at': 'To created at',
    'team-member-payment-detail.label.created_at': 'Created At',
    'team-member-payment-detail.label.from__updated_at': 'From updated at',
    'team-member-payment-detail.label.to__updated_at': 'To updated at',
    'team-member-payment-detail.label.updated_at': 'Updated At',
    'team-member-payment-detail.label.from__deleted_at': 'From deleted at',
    'team-member-payment-detail.label.to__deleted_at': 'To deleted at',
    'team-member-payment-detail.label.deleted_at': 'Deleted At',
    'team-member-payment-detail.label.status': 'Status',

    'team-member-payment-detail.sort.field_label': 'Field',
    'team-member-payment-detail.sort.direction_label': 'Direction',
    'team-member-payment-detail.sort.direction_ascending': 'Ascending',
    'team-member-payment-detail.sort.direction_descending': 'Descending',

    'team-member-payment-detail.modal.title.team_member_payment_detail_delete_permanently': 'Delete Payment Detail',
    'team-member-payment-detail.modal.title.team_member_payment_detail_restore': 'Restore Payment Detail',

    'team-member-payment-detail.modal.message.team_member_payment_detail_delete_permanently':
        'Are you sure that you want to permanently delete this payment detail? This action cannot be undone. | Are you sure that you want to permanently delete these payment details? This action cannot be undone.',
    'team-member-payment-detail.modal.message.team_member_payment_detail_restore': 'Are you sure that you want to restore this payment detail? | Are you sure that you want to restore these payment details?',

    'team-member-payment-detail.success.message.team_member_payment_detail_created': 'Your payment detail has been created',
    'team-member-payment-detail.success.message.team_member_payment_detail_updated': 'Your payment detail has been updated',
    'team-member-payment-detail.success.message.team_member_payment_detail_saved': 'Your payment detail has been saved',
    'team-member-payment-detail.success.message.team_member_payment_detail_restored': 'Your payment detail has been restored | All selected payment details were restored',
    'team-member-payment-detail.success.message.team_member_payment_detail_deleted': 'Your payment detail has been permanently deleted | All selected payment details were permanently deleted',

    'team-member-payment-detail.info.message.payment_detail_already_exists': 'This team member already has a payment detail record. Redirecting to the existing record.',

    'team-member-payment-detail.error.message.team_member_payment_detail_deleted': 'This payment detail was already permanently deleted | These payment details were already permanently deleted',
    'team-member-payment-detail.error.message.team_member_payment_detail_restored': 'This payment detail was already restored | These payment details were already restored',
    'team-member-payment-detail.error.message.error_loading_page': 'Sorry, there was an error loading payment detail.| Sorry, there was an error loading payment details.',
};
